/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESUserRegistration.
 *
 */

import { ReduxUtils } from '@spm/core';

const CREATE_PENDING_CITIZEN_ACCOUNT = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/CREATE_PENDING_CITIZEN_ACCOUNT`
);

const EMAIL_PASSWORD_RESET = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/EMAIL_PASSWORD_RESET`
);

const IS_EMAIL_VERIFIED = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/IS_EMAIL_VERIFIED`
);

const ACTIVATE_EMAIL = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/ACTIVATE_EMAIL`
);

const POST_ACES_ACTIVATION_LINK_EMAIL = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/POST_ACES_ACTIVATION_LINK_EMAIL`
);

const POST_ACES_ACTIVATE_CITIZEN_ACCOUNT = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/POST_ACES_ACTIVATE_CITIZEN_ACCOUNT`
);

const POST_ACES_RESEND_ACTIVATION_LINK_EMAIL = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/POST_ACES_RESEND_ACTIVATION_LINK_EMAIL`
);

const POST_ACES_SEND_FORGOT_USERNAME_EMAIL = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/POST_ACES_SEND_FORGOT_USERNAME_EMAIL`
);

const POST_ACES_ACCOUNT_UNLOCK = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/POST_ACES_ACCOUNT_UNLOCK`
);

const POST_ACES_CHECK_ACCOUNT_ENABLE = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/POST_ACES_CHECK_ACCOUNT_ENABLE`
);

const POST_ACES_SEND_ACCOUNT_UNLOCK_EMAIL = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESUSERREGISTRATION/POST_ACES_SEND_ACCOUNT_UNLOCK_EMAIL`
);

export {
  CREATE_PENDING_CITIZEN_ACCOUNT,
  EMAIL_PASSWORD_RESET,
  IS_EMAIL_VERIFIED,
  ACTIVATE_EMAIL,
  POST_ACES_ACTIVATION_LINK_EMAIL,
  POST_ACES_ACTIVATE_CITIZEN_ACCOUNT,
  POST_ACES_RESEND_ACTIVATION_LINK_EMAIL,
  POST_ACES_SEND_FORGOT_USERNAME_EMAIL,
  POST_ACES_ACCOUNT_UNLOCK,
  POST_ACES_CHECK_ACCOUNT_ENABLE,
  POST_ACES_SEND_ACCOUNT_UNLOCK_EMAIL,
};
